import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';


const accountFinancesRoutes = [
  {
    path: 'finances',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Finances')
      }
    },
    children: [
      {
        path: 'planfacts',
        component: NestedRouteComponent,
        meta: {
          routeName: {
            segmentName: () => translation.tr('Plan-Fact')
          },
          permissions: ['READ_PLAN_FACTS', 'READ_ADVERTISERS']
        },
        children: [
          {
            path: '',
            name: 'planFact',
            component: wrapLegacyRoute('financesController', 'planFact')
          },
          {
            path: 'plans',
            name: 'planList',
            component: wrapLegacyRoute('financesController', 'planList')
          },
          {
            path: 'profitcoefficients',
            name: 'profitCoefficientList',
            component: wrapLegacyRoute('financesController', 'profitCoefficientList')
          }
        ]
      }
    ]
  }
];

export default accountFinancesRoutes;
